<template>
    <div class="">
        <!--企业中心/我的学习-->
        <div v-if="mode == 'enterprise-center'">
            <div v-if="tableData.length > 0">
                <div v-for="(item, key) in tableData" :key="'video-' + key" class="video-list-item">
                    <div class="video-item-image-wrapper">
                        <img :src="item.coverUrl" alt="" class="video-item-image">
                    </div>
                    <div class="video-item-content-wrapper">
                        <div class="video-item-content">
                            <div class="video-item-title">
                                {{ item.title }}
                            </div>
                            <div class="video-item-date">
                                <span>上次学习：</span>
                                {{ item.lastWatchTime }}
                            </div>
                            <div class="video-item-progress-wrapper">
                                <div class="video-progress-label">
                                    已学习{{ item.watchProgress }}%
                                </div>
                                <div class="video-item-progress">
                                    <el-progress :percentage="item.watchProgress" color="rgba(79, 121, 237, 0.3);"
                                        :show-text="false" :stroke-width="8"></el-progress>
                                </div>
                            </div>
                        </div>
                        <div class="video-btn-wrapper">
                            <div class="video-btn" @click="viewCourseDetail(item)">立即学习</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">当前学员还未开始学习，暂无学习记录！</div>
            </div>
        </div>
        <!--学习报告/成员情况-->
        <div v-if="mode == 'study-report-member'">
            <div v-if="tableData.length > 0">
                <div v-for="(item, index) in tableData" :key="'video-' + index" class="video-list-item">
                    <div class="video-item-member-wrapper">
                        <div class="study-report-member-name">
                            {{ item.name }}
                            <!--<div v-if="index==0" class="study-report-member-my">
                                <img src="../assets/img/my.png" alt="">
                            </div>-->
                            <div v-if="item.role == 1" class="study-report-member-role">
                                <div class="study-report-member-role-btn">管理员</div>
                            </div>
                            <div v-if="item.role == 2" class="study-report-member-role">
                                <div class="study-report-member-role-btn">超级管理员</div>
                            </div>
                        </div>
                        <div class="study-report-member-phone">
                            {{ item.mobile }}
                            <span class="study-report-member-Statistics">学习进度：{{ item.studyProgress === -1 ? '--' :
                                item.studyProgress + '%' }}</span>
                            <span class="study-report-member-Statistics">学习时长：{{ item.studyTotalTime === -1 ? '--' :
                                item.studyTotalTime + 'H' }}</span>
                        </div>
                    </div>
                    <div class="video-item-content-wrapper" style="justify-content:flex-end;" v-if="item.enableViewReport">
                        <div class="video-btn-wrapper">
                            <div class="video-btn study-report-member-btn" @click="handleMemberCourse(item)">
                                查看报告
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">当前学员还未开始学习，暂无学习记录！</div>
            </div>
        </div>
        <!--学习报告/课程情况-->
        <div v-if="mode == 'study-report-course'">
            <div v-if="tableData.length > 0">
                <div v-for="(item, key) in tableData" :key="'video-' + key" class="video-list-item">
                    <div class="video-item-image-wrapper">
                        <img :src="item.coverUrl" alt="" class="video-item-image">
                    </div>
                    <div class="video-item-content-wrapper">
                        <div class="video-item-content">
                            <div class="video-item-title">
                                {{ item.courseName }}
                            </div>
                            <div class="video-item-date">
                                {{ item.watchUserCount }}人在学共{{ item.videoTotalTime }}分钟
                            </div>
                        </div>
                        <div class="video-btn-wrapper">
                            <div class="video-btn" @click="handleReportCourse(item)">查看报告</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">当前学员还未开始学习，暂无学习记录！</div>
            </div>
        </div>
        <!--学习报告/课程情况/详情-->
        <div v-if="mode == 'study-course-report-detail'" class="study-course-report-detail">
            <div v-if="tableData.length > 0">
                <div v-for="(item, index) in tableData" :key="'video-' + index" class="video-list-item">
                    <div class="study-course-report-member-wrapper">
                        <div class="study-report-member-name">
                            {{ item.name }}
                            <div v-if="item.myself" class="study-report-member-my">
                                <img src="../assets/img/my.png" alt="">
                            </div>
                            <!-- <div v-if="index==1" class="study-report-member-role">
                                <div class="study-report-member-role-btn">管理员</div>
                            </div> -->
                        </div>
                        <div class="study-report-member-phone">{{ item.mobile }}</div>
                    </div>
                    <div class="video-item-content-wrapper" style="justify-content:flex-end;">
                        <div class="video-progress">
                            观看进度：{{ item.watchProgress }}%
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">当前学员还未开始学习，暂无学习记录！</div>
            </div>
        </div>
        <!--学习报告/成员情况/详情-->
        <div v-if="mode == 'study-member-report-detail'">
            <div v-if="tableData.length > 0">
                <div v-for="(item, key) in tableData" :key="'video-' + key" class="video-list-item member-report-row">
                    <div class="video-item-image-wrapper">
                        <img :src="item.coverUrl" alt="" class="video-item-image">
                    </div>
                    <div class="video-item-content-wrapper">
                        <div class="video-item-content">
                            <div class="video-item-title">
                                {{ item.courseName }}
                            </div>
                            <div class="video-item-date">
                                <span>上次观看时间：</span>
                                {{ item.lastWatchTime }}
                            </div>
                            <div class="video-item-progress-wrapper">
                                <div class="video-progress-label">
                                    观看进度{{ item.studyProgress }}%
                                </div>
                                <div class="video-item-progress">
                                    <el-progress :percentage="item.studyProgress" color="rgba(79, 121, 237, 0.3);"
                                        :show-text="false" :stroke-width="8"></el-progress>
                                </div>
                            </div>
                        </div>
                        <!--<div class="video-btn-wrapper">
                            <div class="video-btn" @click="startStudy(item)">立即学习</div>
                        </div>-->
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">当前学员还未开始学习，暂无学习记录！</div>
            </div>
        </div>
        <!--学习报告/报告列表/详情-->
        <div v-if="mode == 'Report-Overview'" class="study-course-report-detail">
            <div v-if="tableData.length > 0">
                <div v-for="(item, index) in tableData" :key="'video-' + index" class="video-list-item Overview_list">
                    <div class="Overview_rl">

                        <div class="Overview_rl_top">{{ year(item.studyMonth) }}年</div>
                        <div class="Overview_rl_bottom">{{ month(item.studyMonth) }}</div>
                    </div>
                    <div class="Overview_bg">月学习报告</div>
                    <div class="Overview_status" style="color: #349a9a;"><span v-if="item.status == 1">已生成</span> <span
                            v-else>生成中</span>
                    </div>
                    <div class="Overview_createTime">生成时间：{{ item.updateTime }}</div>
                    <div class="Overview_btn">
                        <el-button v-if="item.status == 1" type="primary" plain @click="viewReport(item)

                        ">查看报告</el-button>
                        <el-button type="info" disabled="true" v-else>查看报告</el-button>
                    </div>
                </div>
            </div>
            <div v-else class="no-data-wrapper">
                <img src="../assets/img/nodata.png" alt="" class="no-data-img">
                <div class="no-data-label">暂无记录！</div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        mode: {
            type: String
        },
        tableData: {
            type: Array
        }
    },
    name: '',
    components: {

    },
    data() {
        return {
            dept: '',
            token: ''
        }
    },
    created() {
        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
    },
    mounted() {

    },
    methods: {
        year(num) {
            if (!num) {
                return ''
            }
            const dateStr = num + "";
            const year = dateStr.substring(0, 4);
            return year
        },
        month(num) {
            if (!num) {
                return ''
            }
            const dateStr = num + "";

            const month = String(parseInt(dateStr.substring(4, 6), 10));
            return month
        },
        handleMemberCourse(row) {
            this.$router.push(`/memberInfo/study-report/${row.userId}/${row.deptId}/${this.dept}`);
        },
        handleReportCourse(row) {
            this.$router.push(`/courseReport/${row.recordId}/${this.dept}`);
        },
        viewCourseDetail(row) {
            var recordId = row.recordId;
            this.$router.push(`/courseDetail/center/${recordId}/${this.dept}/${row.courseType}`);
        },
        startStudy(row) {
            // console.log(row);
        },
        //查看报告
        viewReport(row) {
            console.log(row.studyMonth)
            this.$router.push(`/companyReport/${row.studyMonth}`);
        }
    }
}
</script>

<style scoped>
.video-list-item {
    display: flex;
    margin-top: 30px;
}

.video-item-image-wrapper {
    width: 148px;
    height: 104px;
    margin-right: 50px;
    overflow: hidden;
    border-radius: 4px;
}

.video-item-member-wrapper {
    flex: 1;
    /* width: 900px; */
}

.study-course-report-member-wrapper {
    width: 262px;
}

.video-item-image {
    width: 148px;
    height: 104px;
    background: #4F79ED;
    border-radius: 4px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.video-item-image:hover {
    cursor: pointer;
    transform: scale(1.2);
}

.video-item-content-wrapper {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding-bottom: 45px;
    border-bottom: solid #F0F0F0 1px;
}

.video-item-content {
    flex: 1;
    /* width: 700px; */
}

.video-btn-wrapper {
    width: 122px;
    display: flex;
    align-content: center;
}

.video-btn {
    width: 122px;
    height: 34px;
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%);
    border-radius: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 34px;
    margin-top: 35px;
}

.video-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.study-report-member-btn {
    margin-top: 10px;
}

.video-item-title {
    width: 700px;

    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-item-date {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-top: 16px;
}

.video-item-progress-wrapper {
    margin-top: 16px;
    display: flex;
    align-content: center;
}

.video-progress-label {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
}

.video-item-progress {
    width: 324px;
    margin-left: 30px;
    padding-top: 5px;
}

.study-report-member-name {
    flex: 1;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
}

.study-report-member-my {
    margin-left: 8px;
}

.study-report-member-role {
    margin-left: 8px;
}

.study-report-member-role-btn {
    width: 90px;
    height: 28px;
    border-radius: 14px;
    border: 1px solid #F6986D;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F6986D;
    display: flex;
    justify-content: center;
    align-items: center;
}

.study-report-member-phone {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-top: 12px;
}

.study-report-member-Statistics {
    margin-left: 26px;
}

.study-report-member-date {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.video-progress {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.study-course-report-detail {
    padding-bottom: 50px;
}

.no-data-wrapper {
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
}

.Overview_list {
    width: 98%;
    margin: 20px auto;
    height: 100px;

    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.5);
}

.Overview_rl {
    width: 78px;
    height: 82px;
    border: 1px dashed #ccc;
    margin: 8px 10px;

}

.Overview_rl_top {
    width: 100%;
    height: 32px;
    background: #497BEC;
    text-align: center;
    line-height: 32px;
    color: #fff;
    font-weight: 500;
    font-size: 21px;
}

.Overview_rl_bottom {
    font-weight: 500;
    font-size: 26px;
    width: 100%;
    height: 50px;
    color: #497BEC;
    text-align: center;
    line-height: 50px;
}

.Overview_bg {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.Overview_createTime,
.Overview_status {
    height: 100px;
    line-height: 100px;
    width: 320px;
    text-align: center;
    color: #9f9a9a;
}

.Overview_btn {
    margin-left: 60px;
    margin-top: 30px;
}
</style>


